/* eslint-disable default-param-last */
import {
  BY_DECISION,
  BY_TYPE,
} from '../../../components/CertsDetails/PopoverProgressBreakdown';
import {
  SET_PROGRESS_BREAKDOWN_DETAILS,
  SET_PROGRESS_BREAKDOWN_DETAILS_ERROR,
  SET_PROGRESS_BREAKDOWN_DETAILS_LOADING,
} from '../types';

const INITIAL_STATE = {
  byTypeDetails: null,
  byDecisionDetails: null,
  isLoading: false,
  errorMessage: null,
  initialLoadError: false,
};

const linearProgressBarReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case SET_PROGRESS_BREAKDOWN_DETAILS:
      if (action.payload.groupByType === BY_DECISION) {
        return {
          ...state,
          byDecisionDetails: action.payload.data,
          errorMessage: null,
        };
      }

      if (action.payload.groupByType === BY_TYPE) {
        return {
          ...state,
          byTypeDetails: action.payload.data,
          errorMessage: null,
        };
      }

      return state;

    case SET_PROGRESS_BREAKDOWN_DETAILS_LOADING:
      if (action.payload) {
        return {
          ...state,
          isLoading: action.payload,
          errorMessage: null,
          initialLoadError: false,
        };
      }

      return {
        ...state,
        isLoading: action.payload,
      };

    case SET_PROGRESS_BREAKDOWN_DETAILS_ERROR:
      return {
        ...state,
        errorMessage: action.payload.initialLoad ? null : action.payload.error,
        initialLoadError: !!action.payload.initialLoad,
      };

    default:
      return state;
  }
};

export default linearProgressBarReducer;
